var map = {
	"./coal/BillOfMaterial": [
		50126,
		126
	],
	"./coal/BillOfMaterial.js": [
		50126,
		126
	],
	"./coal/Transactions": [
		52214,
		214
	],
	"./coal/Transactions.js": [
		52214,
		214
	],
	"./coal/WhereUsed": [
		55017,
		17
	],
	"./coal/WhereUsed.js": [
		55017,
		17
	],
	"./default/BillOfMaterial": [
		52144,
		144
	],
	"./default/BillOfMaterial.js": [
		52144,
		144
	],
	"./default/Transactions": [
		67092,
		92
	],
	"./default/Transactions.js": [
		67092,
		92
	],
	"./default/WhereUsed": [
		7859,
		859
	],
	"./default/WhereUsed.js": [
		7859,
		859
	],
	"./gold/BillOfMaterial": [
		31141,
		141
	],
	"./gold/BillOfMaterial.js": [
		31141,
		141
	],
	"./gold/Transactions": [
		13881,
		881
	],
	"./gold/Transactions.js": [
		13881,
		881
	],
	"./gold/WhereUsed": [
		91172,
		172
	],
	"./gold/WhereUsed.js": [
		91172,
		172
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99178;
module.exports = webpackAsyncContext;